/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateArticleSentimentV2Config } from 'state/thunks/articlesentimentv2';
import { setTempArticleSentimentConfig } from 'state/slices/articlesentimentv2';
// material
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as BoardActivity } from 'assets/icons/board-activity.svg'
// content
import AdDetails from './addetails/addetails';
import Placements from './placements/placements';
// styles
import injectSheet from 'react-jss'
import styles from './adssection_styles'
import Space from 'material/space/space';
import Preview from './preview/preview';
import Visibility from './visibility/visibility';


/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: ADS SECTION ~~~~~~~~~~ ========== */
const AdsSection = injectSheet(styles)((props) => {
  
  const dispatch = useDispatch()
  const { siteUUID } = useSelector((state) => state.session)
  const { adsConfig: savedAdsConfig, status, articleSentimentUnitId } = useSelector(state => state.articleSentimentV2.articleSentimentConfig)
  const { adsConfig: tempAdsConfig } = useSelector(state => state.articleSentimentV2.tempArticleSentimentConfig)

  const [isUpdating, setIsUpdating] = useState(false)
  const [isOpened, setIsOpened] = useState(false)
  const [selectedPlacementVersion, selectPlacementVersion] = useState('desktop')

  const [isScollIntoView, setIsScrollIntoView] = useState(false)

  useEffect(() => {
    let currentLocation = window.location.href;
    const hasCommentAnchor = currentLocation.includes("?view=adsConfig");
    if(hasCommentAnchor && (status === 'fulfilled' || status === 'rejected')) setIsOpened(true)
  },[status])

  useEffect(() => {
    if(isOpened && !isScollIntoView) scrollToComment()
  }, [isOpened, isScollIntoView])

  const scrollToComment= () => {
    let currentLocation = window.location.href;
    const hasCommentAnchor = currentLocation.includes("?view=adsConfig");
    if (hasCommentAnchor) {
      // fixHeaderPosition()
      const anchorComment = document.getElementById('ads-config');
      if(anchorComment){
        // anchorComment.style.scrollMargin = '100px';
          setTimeout(() => {
            anchorComment.scrollIntoView({ behavior: "smooth",  block: 'center'  })
            setIsScrollIntoView(true)
          }, 700)
      }
    }
  }
  
  const handleToggle = () => setIsOpened(!isOpened)

  const handleSave = useCallback(async (e) => {
    setIsUpdating(true)
    e.stopPropagation()
    const adsConfigRequest = {...tempAdsConfig}
    const response = await dispatch(updateArticleSentimentV2Config({ data: adsConfigRequest, unitUUID: articleSentimentUnitId, section: 'ads' }))
    if(response.payload) setIsOpened(false)
    setIsUpdating(false)
  }, [articleSentimentUnitId, dispatch, tempAdsConfig])

  const handleCancel = useCallback(async () => {
    setIsOpened(false)
    dispatch(setTempArticleSentimentConfig({
      configName: 'adsConfig',
      data: savedAdsConfig
    }))
  }, [dispatch, savedAdsConfig])

  const isChanged = useMemo(() => {
    const isFieldsChanged = !(JSON.stringify(tempAdsConfig) === JSON.stringify(savedAdsConfig));
    return isFieldsChanged
  }, [tempAdsConfig, savedAdsConfig])


  const handleAdsConfigChange = useCallback((property, value) => {
    dispatch(setTempArticleSentimentConfig({
      configName: 'adsConfig',
      data: {
        ...tempAdsConfig,
        [property]: value
      }
    }))
}, [tempAdsConfig, dispatch]);

  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={isUpdating}
      disableSave={!isChanged}
      saveTitle={'Save Changes'}
      icon={<BoardActivity />}
      title='Ads'
    />
  );

  return (
    <ExpandableSection
      className={`expandablesectionv2 adssection ${props.classes.adssection}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={isUpdating}
      disableSave={!isChanged}
    >
      <Space>
        <Space direction={'column'} gap={48}>
          <Visibility {...tempAdsConfig} version={selectedPlacementVersion}  onChange={handleAdsConfigChange} />
          <Placements 
            version={selectedPlacementVersion} 
            selectVersion={selectPlacementVersion}
            onChange={handleAdsConfigChange} 
            {...tempAdsConfig}  
          />
          <AdDetails {...tempAdsConfig} />
        </Space>
        <Preview 
          version={selectedPlacementVersion} 
          selectVersion={selectPlacementVersion}
          onChange={handleAdsConfigChange} 
          {...tempAdsConfig}  
        />
      </Space>
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdsSection